<template>
  <div class="text-area-input" :class="{ disabled }">
    <label :for="id">{{ label }}</label>

    <textarea-autosize
      ref="input"
      v-model="localValue"
      :min-height="minheight"
      :id="id"
      :name="id"
      :maxlength="maxlength"
      :required="required"
      :disabled="disabled"
      @input="update"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    id: String,
    label: String,
    required: Boolean,
    disabled: Boolean,
    maxlength: {
      type: String,
      default: '10000',
    },
    minheight: {
      type: Number,
      default: 69,
    },
  },

  data() {
    return {
      localValue: this.value,
    };
  },

  watch: {
    value(value) {
      this.localValue = value;
    },
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },

    update() {
      const value = this.localValue;
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.text-area-input {
  margin-bottom: $gp;
  position: relative;

  &.disabled {
    opacity: 0.5;
  }

  textarea {
    background-color: var(--theme-background);
    border: solid 1px var(--theme-input-border);
    color: var(--theme-color);
    border-radius: $border-radius;
    padding: $gp * .5 $gp * .75;
    outline: 0;
    font-size: 16px;
    width: 100%;
    resize: none;
    line-height: 1.5;
    overflow-y: hidden;

    &:focus {
      border-color: $color-green-1;
    }
  }

  label {
    color: $color-gray-5;
    background-color: var(--theme-background);
    font-size: 12px;
    position: absolute;
    transform-origin: top left;
    padding: 0 3px;
    transform: translate(13px, -9px);
    font-weight: bold;
    z-index: 1;
  }
}
</style>
